<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    let isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    if (isMobile) {
      this.$store.commit("computer", false);
    }
  },
};
</script>

<style>
@import "../src/assets/style/allstyle";
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  background: #f0f1f6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue